import { type ReactNode } from 'react';
import { type Column } from '@vello/web-theme';

/**
 * Split a trailing `act` column off a column list into the listing's hover-revealed row actions — what the legacy `Table`
 * already does for its own `act` column. `<ListTable {...rowActions(columns)} … />` keeps the buttons out of the cells:
 * they appear on row hover and focus (FX-09) instead of sitting in a column on every row, and the row stays clickable.
 */
export function rowActions<T>(columns: readonly Column<T>[]): { readonly columns: readonly Column<T>[]; readonly actions?: (row: T) => ReactNode } {
  const last = columns[columns.length - 1];
  if (last === undefined || last.key !== 'act') return { columns };
  return { columns: columns.slice(0, -1), actions: (row: T) => last.render(row) };
}
